import { TagFilter } from '@/components/ui/tag-filter';
import { useEscritoriosDasTags, useTags } from '@/hooks/useTags';

export interface FiltroDeTagsProps {
  /** Ids das tags marcadas. */
  value: string[];
  onChange: (ids: string[]) => void;
}

/**
 * O filtro por tags das telas de lista, já abastecido: as tags e categorias visíveis e
 * os escritórios do contexto (na delegação, só os da conta em que se atua). A tela só
 * guarda os ids marcados; quem aplica a regra (OU na categoria, E entre categorias) é
 * ela, no cliente ou no servidor. Entra pela `BarraDaLista` (`filtroDeTags`), que o
 * põe sempre por último na linha dos filtros.
 */
export function FiltroDeTags({ value, onChange }: FiltroDeTagsProps) {
  const { tags, categorias, equipes } = useTags();
  const escritorios = useEscritoriosDasTags();
  return (
    <TagFilter
      tags={tags}
      categorias={categorias}
      escritorios={escritorios}
      equipes={equipes}
      value={value}
      onChange={onChange}
      className="shrink-0"
    />
  );
}
